import React from "react";

interface SkeletonProps {
    style?: React.CSSProperties;
    className?: string;
    width?: string | number;
    height?: string | number;
    radius?: string | number;
    loading?: boolean;
    children?: React.ReactNode;
}

const Skeleton: React.FC<SkeletonProps> = ({
                                               style={},
                                               className="",
                                               width = 40,
                                               height = 40,
                                               radius = 5,
                                               loading = true,
                                               children,
                                           }) => {
    if (!loading) {
        return <>{children}</>;
    }

    const skeletonStyle: React.CSSProperties = {
        width,
        height,
        borderRadius: radius,
        ...style,
    };

    return (
        <div
            className={"matchid-skeleton "+className}
            style={skeletonStyle}
        ></div>
    );
};

export default Skeleton;